<template>
  <section class="p-logmonitor">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="monitor-wrap">
        <section class="c-mt-84 monitor-title">
          <p class="c-fs-32 c-mb c-fw-b c-c-text-color-dark">日志管理分析</p>
          <p class="c-fs-16 c-mt-36 c-mb-56 c-lh-38 c-ta-j">猫维日志管理分析系统是一款国内自主研发的日志集中管理的产品，利用搜索引擎的技术，通过方便灵活的日志搜索分析，为用户提供一个配置简单、
            功能强大、容易使用的日志管理工具，通过对日志进行集中采集和准实时索引，提供搜索、分析、可视化和监控告警等功能，帮助企业进行线上业务实时监控、设备日志数据统计分析。</p>
          <img src="../../assets/monitor/log.svg" class="c-cs-p" preview="monitor-web"/>
        </section>
        <!-- <section>
          <div class="c-d-f c-ai-c c-mt-84">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">MonitorWay WEB应用性能监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-14 c-c-text-grey c-lh-36 c-mt-40 c-pt-56 c-pl-92 c-pb-136 c-p-r">
            <ul>
              <li>在线实时监测WEB应用的性能</li>
              <li>监测指标包括下载速度、访问的延时等指标</li>
              <li>支持分布式多站点采集的方式</li>
            </ul>
            <img src="../../assets/monitor/log.png" class="c-pr-40 pic">
          </div>
        </section> -->
        <section class="c-pb-164 features">
          <div class="c-d-f c-ai-c c-mt-80">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">功能介绍</span>
          </div>
          <div class="c-d-f c-jc-sb c-fw-w c-mt-40 features-wrap">
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/log1.png">
              <div class="c-ml-40">
                <!-- <p class="c-mb-12 c-fs-20 c-c-text-blue">网站和 Web 应用程序性能报告</p> -->
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">可以支持多套ElasticSearch集群数据源接入，可实现海量日志分布式独立存储</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/log2.png">
              <div class="c-ml-40">
                <!-- <p class="c-mb-12 c-fs-20 c-c-text-blue">使用详细的加载时间指标进行故障排除</p> -->
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">支持SYSLOG、AGENT方式收集各种形式的系统日志类型日志采集与格式化处理</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/log3.png">
              <div class="c-ml-40">
                <!-- <p class="c-mb-12 c-fs-20 c-c-text-blue">分权分级管理</p> -->
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">与猫维CMDB资产数据智能关联</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item" style="width: 100%;">
              <img src="../../assets/monitor/log4.png" style="width: 6.4%;">
              <div class="c-ml-40" style="width: 100%;">
                <!-- <p class="c-mb-12 c-fs-20 c-c-text-blue">直观的面板</p> -->
                <p class="c-ta-j c-fs-14 c-lh-28 c-mb-20 c-c-text-grey">日志分析页面</p>
                <img src="../../assets/monitor/log-page.svg" style="width: 100%;">
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width monitor-wrap-mobile">
        <section class="c-mt-40 monitor-title">
          <p class="c-fs-19 c-fw-b c-c-text-color-dark">日志管理分析</p>
          <p class="c-fs-12 c-mt-16 c-mb-24 c-lh-22 c-ta-j">猫维日志管理分析系统是一款国内自主研发的日志集中管理的产品，利用搜索引擎的技术，通过方便灵活的日志搜索分析，为用户提供一个配置简单、
            功能强大、容易使用的日志管理工具，通过对日志进行集中采集和准实时索引，提供搜索、分析、可视化和监控告警等功能，帮助企业进行线上业务实时监控、设备日志数据统计分析。</p>
          <img src="../../assets/monitor/log.svg" preview="monitor-web1"/>
        </section>
        <!-- <section>
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">MonitorWay WEB应用性能监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-13 c-c-text-grey c-lh-28 c-mt-24 c-ptb-20 c-pl-36 c-pr-16 c-boxshadow">
            <ul>
              <li>在线实时监测WEB应用的性能</li>
              <li>监测指标包括下载速度、访问的延时等指标</li>
              <li>支持分布式多站点采集的方式</li>
            </ul>
          </div>
        </section> -->
        <section class="features">
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">功能介绍</span>
          </div>
          <div class="c-mt-24 features-wrap">
            <swiper class="swiper" :options="swiperOption" ref="mySwiper">
              <swiper-slide>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/log1.png">
                    <div class="c-ml-24">
                      <!-- <p class="c-fs-15 c-c-text-blue c-mb-8">网站和 Web 应用程序性能报告</p> -->
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">可以支持多套ElasticSearch集群数据源接入，可实现海量日志分布式独立存储</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/log2.png">
                    <div class="c-ml-24">
                      <!-- <p class="c-fs-15 c-c-text-blue c-mb-8">故障预警</p> -->
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">支持SYSLOG、AGENT方式收集各种形式的系统日志类型日志采集与格式化处理</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/log3.png">
                    <div class="c-d-f c-ai-c c-ml-24">
                      <!-- <p class="c-fs-15 c-c-text-blue c-mb-8">分权分级管理</p> -->
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">与猫维CMDB资产数据智能关联</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-44 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/log4.png">
                    <div class="c-d-f c-ai-c c-ml-24">
                      <!-- <p class="c-fs-15 c-c-text-blue c-mb-8">直观的面板</p> -->
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">日志分析页面</p>
                    </div>
                  </div>
                  <img src="../../assets/monitor/log-page.svg" style="width: 100%;height: auto;margin-top: 15px;">
                </div>
              </swiper-slide>
              <!-- <swiper-slide>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet8.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">多站点采集</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">MonitorWay WEB应用性能监控系统的多站点采集代理部署非常灵活，可以部署在任意的位置，进行WEB应用的监测。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-44 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/config3.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">使用详细的加载时间指标进行故障排除</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">使用TCP瀑布图快速确定加载时间最长的页面元素。 监控诸如 HTML、CSS、JavaScript、图片之类的网站元素及其整体性能和加载指标。
                        如果图片不匹配以及存在影响应用程序性能的不完整或缓慢事务时，发出通知。</p>
                    </div>
                  </div>
                </div>
              </swiper-slide> -->
              <div class="swiper-pagination" id="swiper-pagination1" slot="pagination"></div>
            </swiper>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: 'web',
  data () {
    return {
      swiperOption: {
        ...this.$store.state.swiperOptions,
        pagination: {
          el: '#swiper-pagination999',
          clickable: true
        },
        loop: false
      }
    }
  }
}
</script>

<style lang="scss">
.p-logmonitor {
  @media screen and (min-width: 1180px) {
    min-height: calc(100vh - 90px - 525px);
    background: url('../../assets/monitor/monitor-bg.png') no-repeat;
    background-position: bottom;
    background-size: 100%;
  }
  .monitor-wrap {
    width: 1180px;
    margin: 0 auto;
    .monitor-title {
      img {
        height: 417px;
      }
    }
    .pic {
      position: absolute;
      right: 0;
      top: -100px;
    }
    .features {
      .features-wrap {
        .features-item {
          width: calc(33% - 6px);
          padding: 44px 54px;
          margin-bottom: 14px;
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
          border-radius: 1px;
          img {
            width: 24%;
          }
        }
      }
    }
  }
  .monitor-wrap-mobile {
    .monitor-title {
      img {
        // height: 202px;
        width: 100%;
      }
    }
    .features {
      .features-wrap {
        padding-bottom: 25px;
        .features-item {
          width: 100%;
          padding: 25px 16px;
          background: white;
          text-align: justify;
          img {
            width: 38px;
            height: 38px;
            object-fit: contain;
          }
        }
      }
    }
    .swiper {
      width: 100%;
      --swiper-theme-color: #FF8243;
      .swiper-pagination, .swiper-pagination-bullets {
        bottom: 15px;
        .swiper-pagination-bullet {
          width: 20px;
          height: 3px;
          border-radius: 1.5px;
          margin: 0 4px;
          outline: none;
        }
        .swiper-pagination-bullet-active {
          width: 50px;
        }
      }
    }
  }
}
</style>
